import pluralize from "pluralize";

export const MAX_RANDOM_TEAMS_NAME_LENGTH = 40;

export const normalizeRandomTeamsName = (value: unknown): string =>
    typeof value === "string"
        ? value.replace(/[\u0000-\u001f\u007f]/g, "").replace(/\s+/g, " ").trim().slice(0, MAX_RANDOM_TEAMS_NAME_LENGTH)
        : "";

export const inflectRandomTeamsName = (name: string, count: number): string =>
    // Inflect the final English word only; preserve Korean and other scripts,
    // plus the user's spelling and capitalization in the rest of the phrase.
    name.replace(/[a-z]+$/i, (word) => pluralize(word, count));
